import { Injectable } from '@angular/core';
import { SequenceDetailsResponse } from '@api/sequence/responses/sequence-details.response';
import { Sequence } from '@features/sequence/models/sequence';

@Injectable({
  providedIn: 'root',
})
export class SequenceDetailsConverter {
  fromResponse(response: SequenceDetailsResponse): Sequence {
    return new Sequence(
      response.id,
      response.name,
      response.description,
      response.createdAt,
      response.generatedAt,
      response.file,
      response.convertedSequence
    );
  }
}
